<template>
    <div class="header">
        <span>{{ $t(Content.text) }}</span>
        <div v-show="!isShowReast">
            <i @click="handle(item)" v-for="item in Content.iconArray" :key="item.id" :class="item.icon" style="margin-left:5px"></i>
        </div>
    </div>
</template>

<script>
export default {
    props: ['Content', 'isShowReast'],
    methods: {
        handle(item) {
            this.$emit(item.method);
        }
    }
};
</script>

<style lang="scss" scoped>
.header {
    height: 50px;
    padding: 0 15px;
    border-bottom: 1px solid #c7c7c7;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
    i {
        color: #344962;
        cursor: pointer;
        font-size: 18px;
        font-weight: 600;
    }
}
</style>
